export default "__VITE_ASSET__CAzFPE8Q__"